var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckPersonalDetails = function SvgCheckPersonalDetails(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.6659 43.2126C59.7238 43.2126 63.0136 39.9228 63.0136 35.8648C63.0136 31.8069 59.7238 28.5172 55.6659 28.5172C51.608 28.5172 48.3181 31.8069 48.3181 35.8648C48.3181 39.9228 51.608 43.2126 55.6659 43.2126Z",
    fill: "#0A9928"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2728 63.7309C73.2728 54.0263 65.3705 46.124 55.6659 46.124C55.5273 46.124 55.3886 46.124 55.25 46.124C58.8546 51.1149 61.0728 57.2149 61.0728 63.7309H73.2728Z",
    fill: "#0A9928"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6659 64H6.72705C6.72705 50.5522 17.6793 39.5999 31.1271 39.5999C44.5749 39.5999 55.6659 50.5522 55.6659 64Z",
    fill: "#0A9928"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M31.1273 35.4408C36.7172 35.4408 41.2479 30.9098 41.2479 25.3204C41.2479 19.731 36.7172 15.1999 31.1273 15.1999C25.5375 15.1999 21.0068 19.731 21.0068 25.3204C21.0068 30.9098 25.5375 35.4408 31.1273 35.4408Z",
    fill: "#0A9928"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckPersonalDetails);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "check-personal-details.920ba6735b0c6eae8d539b5f2309253b.svg";